<template>
  <div class="WapFrontPage">
    <div class="page">
      <div class="plogo">
      <logo :logo="logo" :inputStyle="{width:'30vw'}"></logo>
      </div>
      <div class="ptitle">
        <my_title :title="title"></my_title>
      </div>
      <div class="tips">
        PC 端打开 ai4sd.org.cn
        <br>
        注册账号进行比赛
      </div>
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src
 import Logo from '@/components/Logo.vue';
/* import Title from '@/components/wapfrontpage/Title.vue' */
import FPTitle from '@/components/frontpage/Title.vue';
 import Headline from '@/components/wapfrontpage/Headline.vue'
 import RankList from '@/components/waprank/rankList.vue'
 import MyVideo from '@/components/Video.vue';

 export default {
   name: 'WapFrontPage',
   computed: {
     logo () {
       return this.$store.state.logo.main
     },
     logos () {
       return {
         kdxt: this.$store.state.logo.kdxt,
         coco: this.$store.state.logo.coco,
         tulingWhite: this.$store.state.logo.tulingWhite,
         img_coco: '/oss/images/bottombar/coco-qr.png',
       }
     },
 
     v() {
       return this.$store.state.frontpage.videos[0]
     },
     groups() {
       return this.$store.state.enroll.groups
     },
     user () {
       return this.$store.state.auth.user
     },
    title() {
      return this.$store.state.frontpage.title
    },
     indexOfGroup() {
       return {
         s: 1,
         m: 2,
         l: 3
       }
     }
   },
   data() {
     return {
       fcg: 's',
       info: []
     }
   },
   methods: {
     login() {
       this.$router.push({name: 'account', params: {type: 'login'}})
     },
     myPage() {
       
       this.$router.push({name: 'WapSharePage'})
     },
     rankMore() {
       this.$router.push({name: 'waprankpage'})
     },
     focus(c) {
       this.fcg =c
       this.fetchData()
     },
     fetchData() {
      let round = this.$store.state.game_year + '-1';
       let group = this.indexOfGroup[this.fcg];
       let uri = '/api/rank/?group='+group;
       this.$http.get(uri)
           .then(res => {
             this.info = res.data.slice(0,5).map(d=>
               {return {rank:d.rank,
                        name:d.username,
                        score: d.score,
                        area:d.area_name.split(' ')[0]}})
           })
 
  
     }

   },
   mounted () {
     this.fetchData();
       },
   components: {

     my_video: MyVideo,
     logo: Logo,
     my_title: FPTitle,
     head_line: Headline,
     rank_list: RankList
   }
 }
</script>
<style scoped>
 .WapFrontPage{
   min-height: 100vh;
   background-image: url('/oss/images/frontpage/header-2025.png');
   background-size: 100%;
   /* background-repeat: no-repeat; */
 }
 .page {
   min-height: 75vh;
   display: flex;
   flex-direction: column;
   align-items:center;
 }
 .page2{
   min-height: 45vh !important;
 }
 .ptitle {
   /* height: 30vh; */
   margin-top: 12vh;
 }
 .pbutton{
   width: 24vw;
   font-size: 4vw;
   line-height: 10vw;
   background-color: var(--blue);
   border-radius: 5px;
   text-align: center;
   margin-top: 6vh;
 }
 .plogo {
   display: flex;
   width: 100vw;
   align-items:center;
  justify-content:center;
   padding-top: 5vh;
 }
 .tips{
   font-size: 4.5vw;
   margin-top: 2vh;
   text-align: center;
 }
 .about, .organizer, .contact{
   background-color: rgba(0,0,0,1);
   padding-top: 5vh;
   display: flex;
   flex-direction:column;
   align-items:center;
 }
 .rank{
   background-color: rgba(0,0,0,1);
   min-height: 25vh;
   display: flex;
   flex-direction:column;
   align-items:center;
 }
 .about{
   /* height: 50vw; */
 }

 .group{
   display: flex;
   align-items:center;
   justify-content:center;
 }
.group .bt{
   width: 25vw;
   height: 7.35vw;
   font-size: 3vw;
   line-height: 7.35vw;
   background-image: url(/oss/images/wap/rank/button-other.png);
   background-size: 25vw;
   background-repeat: no-repeat;
   background-position: center;
   margin: 1px;
   text-align:center;
 }
 .group .bt.focus{
   background-image: url(/oss/images/wap/rank/button-light.png);
   color: rgba(240,240, 240, 0.8);
 }
 .bbutton{
   width: 8em;
   font-size: 4vw;
   line-height: 10vw;
   background-color: var(--blue);
   border-radius: 5px;
   text-align: center;
   margin-top: 3vh;
 }

 .hd{
      width: 90vw;
   display: flex;
   height: 40px;
   font-size: 14px;
   align-items:center;
   justify-content:space-around;
   color: rgba(200, 200, 200, 0.6);
 }

 .img  {
   flex-basis: 50px;
 }
 
 .logos{
   display: flex;
   align-items: center;
   justify-content:space-around;
   width: 90vw;
 }
 .qr{
   width: 30vw;
   height: 30vw;
 }
</style>
